export const buttonStyles = {
  redoButton: {
    minWidth: 0,
    width: '56px',
    height: '56px',
    p: 0,
    borderRadius: '50%',
    backgroundColor: 'rgba(255, 255, 255, 0.2)',
    '&:hover': { backgroundColor: 'rgba(255, 255, 255, 0.2)' }
  },

  recordButton: {
    minWidth: 0,
    width: '64px',
    height: '64px',
    p: 0,
    borderRadius: '50%',
    backgroundColor: 'transparent',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    '&:hover': { backgroundColor: 'transparent' }
  },

  proceedButton: {
    minWidth: 0,
    width: '56px',
    height: '56px',
    p: 0,
    borderRadius: '50%',
    backgroundColor: 'white',
    '&:hover': { backgroundColor: 'white' }
  },

  discardButton: {
    backgroundColor: '#FF3B30',
    fontSize: '16px',
    borderRadius: '12px',
    py: '14px',
    fontWeight: 400,
    flex: 1,
    '&:hover': { backgroundColor: '#FF3B30' }
  },

  cancelButton: {
    backgroundColor: '#f4f4f4',
    color: '#2e2d7e',
    fontSize: '16px',
    borderRadius: '12px',
    py: '14px',
    fontWeight: 400,
    flex: 1,
    '&:hover': { backgroundColor: '#f4f4f4' }
  }
}; 